import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { fetchDestinations } from '../../services/api';

function MobileMenu({ isOpen, onClose }) {
    const [activeMenu, setActiveMenu] = useState(null);
    const [activeShopMenu, setActiveShopMenu] = useState(false); // Shop submenu state
    const [destinations, setDestinations] = useState([]);
    const menuRefs = useRef({});

    // Toggle dropdown menu
    const toggleMenu = (index) => {
        if (index !== 6) {
            setActiveMenu(activeMenu === index ? null : index);
        }
    };

    // Handle Shop menu separately
    const toggleShopMenu = (e) => {
        e.stopPropagation(); // Prevent menu from closing
        setActiveShopMenu(!activeShopMenu);
    };

    // Fetch destinations for dropdown
    useEffect(() => {
        const loadDestinations = async () => {
            try {
                const response = await fetchDestinations(1, '', '');
                if (response.success && response.destinations) {
                    setDestinations(response.destinations);
                }
            } catch (error) {
                console.error('Error loading destinations for mobile menu:', error);
            }
        };

        loadDestinations();
    }, []);

    // Apply height animation when activeMenu changes
    useEffect(() => {
        Object.keys(menuRefs.current).forEach((key) => {
            const submenu = menuRefs.current[key];
            if (submenu) {
                submenu.style.height = activeMenu == key ? `${submenu.scrollHeight}px` : "0px";
            }
        });
    }, [activeMenu]);

    return (
        <div className={`th-menu-wrapper onepage-nav ${isOpen ? "th-body-visible" : ""}`}
            style={{ visibility: isOpen ? "visible" : "hidden" }}>

            <div className="th-menu-area text-center">
                <button className="th-menu-toggle" onClick={onClose} aria-label="Close">
                    <i className="fal fa-times" />
                </button>

                <div className="mobile-logo">
                    <Link to="/">
                        <img src="/assets/img/logo.svg" alt="WingsTours" />
                    </Link>
                </div>

                <div className="th-mobile-menu">
                    <ul>
                        {/* Home */}
                        <li className={` ${activeMenu === 1 ? "th-active" : ""}`}>
                            <Link to="/">Home</Link>
                        </li>

                        {/* Destinations with Dropdown */}
                        <li className={`menu-item-has-children ${activeMenu === 2 ? "th-active" : ""}`}>
                            <a
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    toggleMenu(2);
                                }}
                            >
                                Destinations
                                <span className="mean-expand" style={{ fontSize: '18px', float: 'right' }}>
                                    {activeMenu === 2 ? '-' : '+'}
                                </span>
                            </a>
                            <ul
                                className="sub-menu"
                                ref={(el) => menuRefs.current[2] = el}
                                style={{
                                    overflow: 'hidden',
                                    transition: 'height 0.3s ease',
                                    height: '0px'
                                }}
                            >
                                <li><Link to="/destinations" onClick={onClose}>All Destinations</Link></li>
                                {destinations.map((destination) => (
                                    <li key={destination.id}>
                                        <Link
                                            to={`/destinations?destination=${destination.id}`}
                                            onClick={onClose}
                                        >
                                            {destination.title}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </li>

                        <li><Link to="/tours">Our Tours</Link></li>
                        <li><Link to="/about">About Us</Link></li>
                        <li><Link to="/contact">Contact us</Link></li>
                        <li><Link to="/blogs">Blog</Link></li>


                    </ul>
                </div>
            </div>
        </div>
    );
}

export default MobileMenu;
